var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import Kinesis from "./kinesis";
import IpInfo from "./ipInfo";
import { v4 as uuidv4 } from "uuid";
import Traits from "./traits";
export default class Client {
  constructor(params = {}) {
    this.kinesis = new Kinesis("analytics-stream");
    this.traits = params.traits_namespace ? new Traits(params.traits_namespace) : new Traits();
    this.defaultDatabase = params.defaultDatabase;
    this.defaultTable = params.defaultTable;
  }
  track(name, params) {
    return __async(this, null, function* () {
      var _a;
      yield this.recordLocationIfRequired();
      const user_id = (_a = window.Tint) == null ? void 0 : _a.anonymous_uid;
      const traits = this.traits.get();
      const properties = __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, params), {
        uuid: user_id
      }), traits), {
        id: uuidv4()
        // unique ID
      });
      if (window.TINT_LOG) {
        console.log(`tracking: ${name} - ${JSON.stringify(properties)}`);
      }
      return yield this._track(name, properties);
    });
  }
  recordTraits(params) {
    return __async(this, null, function* () {
      this.traits.store(params);
    });
  }
  recordLocationIfRequired() {
    return __async(this, null, function* () {
      let locationIdentified = localStorage.getItem("tint_location_identified") || false;
      if (!locationIdentified) {
        yield this.recordLocation();
      }
    });
  }
  _track(name, params) {
    return __async(this, null, function* () {
      var _a;
      const event = {
        type: "track",
        event: name,
        user_id: (_a = window.Tint) == null ? void 0 : _a.anonymous_uid,
        properties: params,
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      };
      if (this.defaultDatabase && this.defaultTable) {
        event.database = this.defaultDatabase;
        event.table = this.defaultTable;
      }
      const data = JSON.stringify(event);
      return yield this.kinesis.send(data);
    });
  }
  recordLocation() {
    return __async(this, null, function* () {
      const locationInfo = yield new IpInfo().getLocationInfo();
      if (locationInfo) {
        this.traits.store(locationInfo);
      }
    });
  }
}
